import { render, staticRenderFns } from "./QuestionButton.vue?vue&type=template&id=6a7e9714"
import script from "./QuestionButton.vue?vue&type=script&lang=js"
export * from "./QuestionButton.vue?vue&type=script&lang=js"
import style0 from "./QuestionButton.vue?vue&type=style&index=0&id=6a7e9714&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports